//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/** @jsxImportSource @emotion/react */

export const infoOptionsStyles = {
  container: {
    display: 'flex',
    gap: '5px',
    width: '100%',
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    margin: '0px 0px 0 0px',
    width: '100%',
  },
  linkItem: {
    color: 'inherit',
    textDecoration: 'inherit',
    width: '100%',
    display: 'block',
  },
  spanStyle: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '21.78px',
    color: '#33333D',
  },
  cardContainerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '97.5%',
  },
  cardStyle: {
    marginBottom: '16px',
  },
  navBarContainer: {
    backgroundColor: '#EDF5FF',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '150px',
  },
  headerContainer: {
    marginLeft: '50px',
    paddingBottom: '10px',
  },
  headerTitle: {
    fontFamily: 'Inter',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '26px',
    color: '#33333D',
    paddingBottom: '5px',
  },
  headerSubtitle: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#5C5C5C',
  },
  pluginBarImage: {
    marginRight: '50px',
    height: '100px',
  },
  featuredPluginsContainer: {
    border: '1px solid #E4E4F0',
    boxShadow: '0px 2px 4px 0px #0000001A',
    paddingBottom: '35px',
  },
  featuredPluginsTitle: {
    fontFamily: 'Inter',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '21.78px',
    color: '#33333D',
    paddingBottom: '50px',
    paddingTop: '25px',
    marginLeft: '50px',
  },
  cardsContainer: {
    display: 'flex',
    marginLeft: '12vh',
    marginTop: '10px',
    gap: '4vh',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  paginationButton: {
    margin: '0 5px',
    padding: '10px',
    cursor: 'pointer',
    backgroundColor: '#E4E4F0',
    color: '#424242',
    border: '1px solid #D3D9DE',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  directionButton: {
    margin: '0 5px',
    padding: '10px',
    cursor: 'pointer',
    backgroundColor: '#E4E4F0',
    color: '#8F8F8F',
    border: '1px solid #D3D9DE',
    borderRadius: '25%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  activePaginationButton: {
    backgroundColor: '#4C5AB7',
    color: '#FFFFFF',
    border: '1px solid transparent',
    borderRadius: '50%',
  },
  footer: {
    height: '6vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#1D1D23',
    color: '#E4E4F0',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '2.4vw',
    bottom: 0,
  },
  allPluginsHeader: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '21.78px',
    color: '#33333D',
    paddingBottom: '25px',
    paddingTop: '25px',
    marginLeft: '5vh',
    display: 'flex',
    alignItems: 'center',
  },
  pluginCountBadge: {
    background: '#C8DFFF',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '24px',
    color: '#043ACE',
    width: '30px',
    height: '20px',
    borderRadius: '200px',
    marginLeft: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterSelect: {
    border: 'none',
    outline: 'none',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0.16px',
    color: '#1D1D23',
    backgroundColor: 'transparent',
  },
  cardsWrapper: {
    display: 'flex',
    gap: '20px',
    rowGap: '40px',
    marginLeft: '5vh',
  },
  solutionCardContainer: {
    display: 'flex',
    border: '0.12vh solid #E4E4F0',
    borderRadius: '0.56vh',
    marginBottom: '1.21vh',
    width: '39vh',
    height: '100%',
    minHeight: '330px',
    justifyContent: 'flex-start',
    padding: '0 15px 15px 15px',
  },
  solutionCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  solutionCardSvg: {
    marginRight: '10px',
    height: '25px',
    maxWidth: '50%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  solutionCardNameLabel: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#0550DC',
    border: '1px solid #EDF5FF',
    backgroundColor: '#EDF5FF',
    paddingLeft: '5px',
    paddingRight: '5px',
    display: 'inline-block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  solutionCardTitle: {
    fontFamily: 'Inter',
    fontSize: '15px',
    fontWeight: 700,
    lineHeight: '19px',
    color: '#1D1D23',
    margin: '10px 0',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  solutionCardText: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: '#4A4A56',
    margin: '10px 0',
    paddingBottom: '20px',
  },
  solutionCardFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
  },
  solutionCardButton: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '17px',
    color: '#0550DC',
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: '3px',
    padding: '1vh 2vh',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    display: 'flex',
  },
  solutionCardButtonIcon: {
    marginLeft: '5px',
  },
  pluginCardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px',
    border: '1px solid #E4E4F0',
    borderRadius: '5px',
    marginBottom: '10px',
    width: '45vh',
    height: '300px',
    backgroundColor: 'white',
  },
  pluginCardNameLabel: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#0550DC',
    border: '1px solid #EDF5FF',
    backgroundColor: '#EDF5FF',
    width: '70px',
    paddingLeft: '0.8vh',
    margin: 0,
    borderRadius: '5px',
  },
  pluginCardTitle: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '19px',
    color: '#1D1D23',
    marginTop: '5px',
  },
  pluginCardUpdated: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '19px',
    color: '#3D5466',
    marginTop: '5px',
  },
  pluginCardText: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: '#4A4A56',
    margin: 0,
  },
  pluginCardFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#3D5466',
  },
  searchInput: {
    height: '30px',
    width: '45vh',
    border: '1px solid #D3D3E5',
    borderRadius: '5px',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: 300,
    lineHeight: '18px',
    letterSpacing: '0.16px',
    color: '#3D5466',
  },
};
